/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ArrowRightLeftIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="arrow-right-left"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M7 7L19.5 7M19.5 7L15.081 11.419M19.5 7L15.081 2.581" data-tinysvg-shape="arrow" data-tinysvg-arrow="7 7 19.5 7 50" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17 17L4.5 17M4.5 17L8.919 12.581M4.5 17L8.919 21.419" data-tinysvg-shape="arrow" data-tinysvg-arrow="17 17 4.5 17 50" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
